import { call, put } from "redux-saga/effects";
import { dispatchAction } from "../create-actions";


function listFetchSaga(listActions, service) {
    return function* (action) {
        try {
            const { data, error } = yield call(service, action.payload.params, action.payload.filters);
            if(data) {
                yield put(dispatchAction(listActions.FETCHED, {params: action.payload.params, filters: action.payload.filters}, data, null));
            } else{
                yield put(dispatchAction(listActions.FETCH_FAILED, {params: action.payload.params, filters: action.payload.filters }, null, error));
            }
        } catch(error) {
            yield put(dispatchAction(listActions.FETCH_FAILED, {params: action.payload.params, filters: action.payload.filters }, null, error));
        }
    };
}

function createSaga(listActions, service) {
    return function* (action) {
        try {
            const { data, error } = yield call(service, action.payload.data);
            if(data) {
                yield put(dispatchAction(listActions.CREATED, {params: action.payload.params, filters: action.payload.filters}, data, null));
            } else{
                yield put(dispatchAction(listActions.FAILED_CREATE, {params: action.payload.params, filters: action.payload.filters }, null, error));
            }
        } catch(error) {
            yield put(dispatchAction(listActions.FAILED_CREATE, {params: action.payload.params, filters: action.payload.filters }, null, error));
        }
    };
}

function updateSaga(listActions, service) {
    return function* (action) {
        try {
            const { data, error } = yield call(service, action.payload.data);
            if(data) {
                yield put(dispatchAction(listActions.UPDATED, {params: action.payload.params, filters: action.payload.filters}, data, null));
            } else{
                yield put(dispatchAction(listActions.FAILED_UPDATE, {params: action.payload.params, filters: action.payload.filters }, null, error));
            }
        } catch(error) {
            yield put(dispatchAction(listActions.FAILED_UPDATE, {params: action.payload.params, filters: action.payload.filters }, null, error));
        }
    };
}

export {
    listFetchSaga,
    createSaga,
    updateSaga
};